import * as React from 'react';

export const CustomizeTemplate = React.lazy(
  () => import('./CustomizeTemplate')
);
